import React, { useState } from 'react';
import PivotTableUI from 'react-pivottable/PivotTableUI';
import 'react-pivottable/pivottable.css';
import TableRenderers from 'react-pivottable/TableRenderers';
import Plot from 'react-plotly.js';
import createPlotlyRenderers from 'react-pivottable/PlotlyRenderers';
import { pivotTableHasValues, customAggregators } from '../utils/pivot';
import { MailchimpSignupForm } from './mailchimpSignupForm/MailchimpSignupForm.jsx';
import './Pivot.css';

// create Plotly renderers via dependency injection
const PlotlyRenderers = createPlotlyRenderers(Plot);
const data = require('../data-202604.json');
const dataValues = data.data.map(({ drug, drugType, patentType, status, statusFdaApproval, statusOPBook }) => (
  [drug, drugType, patentType, status, statusFdaApproval, statusOPBook]
));
const dataPivot = [
  ['Drug', 'Drug Type', 'Patent Type', 'Status', 'FDA Approval', 'Orange/Purple Book'],
  ...dataValues,
]

const Pivot = ({
  checkedStorage,
  showPopup,
  setHasSubmitted,
}) => {
  const [state, setState] = useState({
    aggregatorName: 'Count'
  });

  if (data) {
    return (
      <div className={`Main pivot-table-container ${checkedStorage && showPopup && 'subscribe-overlay'}`}>
        {checkedStorage && showPopup && (
          <MailchimpSignupForm setHasSubmitted={setHasSubmitted} />
        )}
        <>
          <div className="container">
            <div className="filters-heading">
              <button
                className={`btn btn-grey btn-clear ${pivotTableHasValues(state) === false && 'hidden'}`}
                onClick={() => setState()}
              >
                Clear Data
              </button>
            </div>
          </div>
          <div className="container container-scroll-x">
            <PivotTableUI
              data={dataPivot}
              onChange={s => setState(s)}
              renderers={Object.assign({}, TableRenderers, PlotlyRenderers)}
              aggregators={customAggregators}
              {...state}
            />
          </div>
        </>
      </div>
    );
  }
  else {
    return ('Loading');
  }
};

export { Pivot }
